/**
 * Enumerate additional input control types for eArhiv
 */
export enum EarhivInputControlTypes {
  EDITABLE_ITEMLIST = 110,
  ARHIVSKA_OZNAKA = 112,
  GEONAMES_INTEGRATION = 114,
  VIAF_INTEGRATION = 116,
  RANGE_KOMPLEKSNI_INPUT = 118,
  VRIJEME_KOMPLEKSNI_INPUT = 120,
  LAZY_DROPDOWN = 124,
  DEDUPLICATION_AGENT_DROPDOWN = 125,
  POJAVNI_OBLIK_NAZIV_INPUT = 126,
  ROK_CUVANJA_TREE_INPUT = 127,
  LOCATION_FROM_STORAGE = 128,
  ARHIVSKA_KLASIFIKACIJA = 129,
  BASIC_FILE_INPUT = 130,
  KLASIFIKACIJSKI_SIFRARNIK_INPUT = 131,
  ROK_CUVANJA_HIERARCHY_DROPDOWN = 132,
  UPRAVNA_STVAR_INPUT = 133,
  JEDINICA_GRADIVA_INHERITABLE_ATTRIBUTE_INPUT = 134,
  DEDUPLICATION_MJESTO_DROPDOWN = 135,
  POJAVNI_OBLIK_INHERITABLE_ATTRIBUTE_INPUT = 136
}
